export function bindTaillightText(element: HTMLElement | null, text: string) {
  if (!element) throw new Error('Taillight CSS source is unavailable.')
  const nodes: Array<{node: Text; start: number; end: number}> = []
  const walker = element.ownerDocument.createTreeWalker(element, NodeFilter.SHOW_TEXT)
  let offset = 0
  let node = walker.nextNode()
  while (node) {
    if (node instanceof Text) {
      nodes.push({node, start: offset, end: offset + node.length})
      offset += node.length
    }
    node = walker.nextNode()
  }
  if (element.textContent !== text) throw new Error('Taillight native DOM does not match its prepared source.')
  function endpoint(position: number) {
    let lower = 0
    let upper = nodes.length - 1
    while (lower <= upper) {
      const middle = Math.floor((lower + upper) / 2)
      const entry = nodes[middle]
      if (!entry) break
      if (position < entry.start) upper = middle - 1
      else if (position > entry.end) lower = middle + 1
      else return {node: entry.node as Node, offset: position - entry.start}
    }
    return {node: element as Node, offset: 0}
  }
  return {
    element,
    range(start: number, end: number) {
      if (!Number.isInteger(start) || !Number.isInteger(end) || start < 0 || end < start || end > text.length) {
        throw new RangeError('Invalid Taillight DOM range.')
      }
      const from = endpoint(start)
      const to = endpoint(end)
      const range = element.ownerDocument.createRange()
      range.setStart(from.node, from.offset)
      range.setEnd(to.node, to.offset)
      return range
    },
  }
}

export type TaillightTextBinding = ReturnType<typeof bindTaillightText>
